import { Calendar, MapPin } from "lucide-react";
import { SectionTitle, EmptyState } from "@/components/platform/PortalLayout";

const fmt = (d) => { try { return new Date(d).toLocaleString(undefined, { weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }); } catch { return d; } };

function statusOf(s) {
  if (s.status) return s.status;
  try { return new Date(s.start_time) < new Date() ? "completed" : "scheduled"; } catch { return "scheduled"; }
}
const BADGE = { scheduled: "text-white border-white/40", completed: "bg-white text-black border-white", canceled: "text-white/40 border-white/20", rescheduled: "text-white border-white/40", missed: "text-white/40 border-white/20" };

export default function MySchedule({ sessions = [], nextRetest }) {
  const sorted = [...sessions].sort((a, b) => new Date(a.start_time) - new Date(b.start_time));
  return (
    <div data-testid="my-schedule">
      <SectionTitle>My Schedule</SectionTitle>
      {nextRetest && (
        <div className="bg-[#121212] border border-white/10 p-4 mb-4 flex items-center gap-3" data-testid="schedule-retest">
          <Calendar size={16} className="text-white/50" />
          <div><p className="font-bold text-sm">Next Retest</p><p className="text-white/50 text-xs">{fmt(nextRetest)}</p></div>
        </div>
      )}
      {sorted.length === 0 ? <EmptyState testid="schedule-empty">Your upcoming sessions, evaluations and events will appear here once your coach schedules them.</EmptyState> : (
        <div className="border border-white/10 bg-[#121212] divide-y divide-white/5" data-testid="schedule-list">
          {sorted.map((s) => {
            const st = statusOf(s);
            return (
              <div key={s.id} className="p-4 flex items-center justify-between gap-3">
                <div className="min-w-0">
                  <p className="font-bold text-sm truncate">{s.title}</p>
                  <p className="text-white/50 text-xs mt-0.5 flex items-center gap-3 flex-wrap"><span className="flex items-center gap-1"><Calendar size={12} /> {fmt(s.start_time)}</span>{s.location && <span className="flex items-center gap-1"><MapPin size={12} /> {s.location}</span>}</p>
                </div>
                <span className={`font-mono-accent text-[10px] tracking-[0.15em] uppercase border px-2 py-0.5 shrink-0 ${BADGE[st] || BADGE.scheduled}`}>{st}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
